<template>
  <div class="container">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多啦"
      :immediate-check="true"
      @load="load_more"
    >
      <div
        class="main"
        :class="{ bg01: index % 2 == 0, bg02: index % 2 != 0 }"
        v-for="(item, index) in list"
        :key="index"
        @click="linkto(item.cert_image)"
      >
        <div style="padding: 10px">
          <p style="margin-top: 10px">{{ item.title }}</p>
          <div style="font-size: 12px; padding: 20px 0">
            <p>发证机构:{{ item.jigou }}</p>
            <p>获取日期:{{ item.get_date }}</p>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  name: "zhengshulist",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
    };
  },
  created() {
    this.$axios({
      method: "post",
      url: "/api/cert/list",
    }).then((res) => {
      if (res.data.code != 0) {
        this.$toast(res.data.msg);
      } else {
        this.list = res.data.data.list;
      }
    });
  },
  methods: {
    load_more() {
      this.page += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/cert/list",
            data: that.qs.stringify({
              page: that.page,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              that.list = that.list.concat(res.data.data.list);
            }
            that.loading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.finished = true;
            } else {
              that.finished = false;
            }
          });
      }, 500);
    },
    linkto(img) {
      localStorage.setItem("zsimg", img);
      this.$router.push("/zhengshudetail");
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
}
.bg01 {
  background-image: url("https://pic-cdn.bigdatajy.com/wenming/static/img/zs01.png");
}
.bg02 {
  background-image: url("https://pic-cdn.bigdatajy.com/wenming/static/img/zs02.png");
}
.main {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: white;
  width: 94%;
  margin: 10px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/zhengshulist.vue